export default __webpack_public_path__ + "static/media/prize-4.c72c945a.webp";